import React from 'react';
import { CreateButton, useTranslate } from 'react-admin';
import EmptyStateImage from '../../assets/empty-state.png';

const EmptyList = (props) => {
  const translate = useTranslate();
  const isLoading = props.mode === 'loading';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: 600,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <div>
        <img src={EmptyStateImage} alt="Empty State" style={{ width: 250 }} />
      </div>
      <div style={{ fontSize: 20, marginTop: 20 }}>
        {isLoading
          ? translate('ra.page.loading', { _: 'Yükleniyor...' })
          : translate('ra.page.empty', { _: 'Oops!' })}
      </div>
      <div style={{ fontSize: 14, marginTop: 15 }}>
        {props.customMessage
          ? props.customMessage
          : isLoading
            ? translate('ra.message.loading', { _: 'Lütfen bekleyin...' })
            : translate('ra.navigation.no_results', { _: 'Görüntülenecek veri bulunamadı.' })}
      </div>
      {!isLoading && !props.noCreate && (
        <div style={{ marginTop: 20 }}>
          <CreateButton />
        </div>
      )}
    </div>
  );
};

export default EmptyList;